import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4f77e074&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f77e074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f77e074')) {
      api.createRecord('4f77e074', component.options)
    } else {
      api.reload('4f77e074', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=4f77e074&scoped=true", function () {
      api.rerender('4f77e074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mchApp/List.vue"
export default component.exports